import React from 'react';

class ECIQuickGuide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showQuickGuide: false,
      showBeforeYouBegin: false,
      showStep1: false,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      showStep5: false,
      showErrorHandling: false
    };
  }

  toggleQuickGuide = () => {
    this.setState({ showQuickGuide: !this.state.showQuickGuide });
  };

  toggleBeforeYouBegin = () => {
    this.setState({ showBeforeYouBegin: !this.state.showBeforeYouBegin });
  };

  toggleStep1 = () => {
    this.setState({ showStep1: !this.state.showStep1 });
  };

  toggleStep2 = () => {
    this.setState({ showStep2: !this.state.showStep2 });
  };

  toggleStep3 = () => {
    this.setState({ showStep3: !this.state.showStep3 });
  };

  toggleStep4 = () => {
    this.setState({ showStep4: !this.state.showStep4 });
  };

  toggleStep5 = () => {
    this.setState({ showStep5: !this.state.showStep5 });
  };

  toggleErrorHandling = () => {
    this.setState({ showErrorHandling: !this.state.showErrorHandling });
  };

  render() {
    const { getComponent } = this.props;
    const Collapse = getComponent ? getComponent("Collapse") : null;

    return (
      <div id="eciQuickGuide" style={{ margin: '20px 0', border: '1px solid #e0e0e0', borderRadius: '6px', backgroundColor: '#fafafa' }}>
        <div
          onClick={this.toggleQuickGuide}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '12px 16px',
            cursor: 'pointer',
            backgroundColor: '#f5f5f5',
            borderRadius: this.state.showQuickGuide ? '6px 6px 0 0' : '6px',
            borderBottom: this.state.showQuickGuide ? '1px solid #e0e0e0' : 'none'
          }}
        >
          <div>
            <h4 style={{ margin: 0, fontSize: '16px', fontWeight: 'bold', color: '#333' }}>
              Quick Guide
            </h4>
            <p style={{ margin: '4px 0 0 0', fontSize: '13px', color: '#666' }}>
              A step-by-step guide to authenticate, retrieve compliance content, and render it using sandbox credentials.
            </p>
          </div>
          <svg className="arrow" width="20" height="20" style={{ flexShrink: 0, marginLeft: '12px' }}>
            <use href={this.state.showQuickGuide ? "#large-arrow-down" : "#large-arrow"} xlinkHref={this.state.showQuickGuide ? "#large-arrow-down" : "#large-arrow"} />
          </svg>
        </div>

        <div
          style={{
            height: this.state.showQuickGuide ? 'auto' : '0px',
            overflow: 'hidden',
            padding: this.state.showQuickGuide ? '16px' : '0px 16px',
          }}
        >

        {/* ── Before You Begin ── */}
        <div className={this.state.showBeforeYouBegin ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleBeforeYouBegin} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Before You Begin
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showBeforeYouBegin ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showBeforeYouBegin}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>You will need the following from Mitratech (see your onboarding contact):</p>
                <table style={{ width: '60%', borderCollapse: 'collapse', border: '1px solid #ccc', marginTop: '15px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#e0e0e0' }}>
                      <th style={thStyle}>Item</th>
                      <th style={thStyle}>Used for</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={tdStyle}><code>client_id</code> + <code>client_secret</code></td>
                      <td style={tdStyle}>The HTTP Basic header on the token request</td>
                    </tr>
                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                      <td style={tdStyle}>Partner Admin <code>username</code> + <code>password</code> (a.k.a. API Admin credentials)</td>
                      <td style={tdStyle}>The credentials exchanged for a bearer token</td>
                    </tr>
                    <tr>
                      <td style={tdStyle}><code>x-api-key</code></td>
                      <td style={tdStyle}>Required header on every endpoint except <code>/v2/oauth/token</code></td>
                    </tr>
                  </tbody>
                </table>
                <p style={{ marginTop: '15px' }}>All examples below use <strong>placeholders</strong> (<code>&lt;CLIENT_ID&gt;</code>, <code>&lt;CLIENT_SECRET&gt;</code>, <code>&lt;USERNAME&gt;</code>, <code>&lt;PASSWORD&gt;</code>, <code>&lt;ACCESS_TOKEN&gt;</code>, <code>&lt;X_API_KEY&gt;</code>, <code>&lt;REFRESH_TOKEN&gt;</code>). Never commit real credentials to source control.</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Sandbox Base URL</h4>
                <p>All endpoint paths in this guide are relative to the <strong>sandbox</strong> base URL:</p>
                <pre style={preStyle}>{`https://restapis.alpha01.trustmineral-staging.com`}</pre>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Step 1 — Obtain OAuth 2.0 Credentials ── */}
        <div className={this.state.showStep1 ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleStep1} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Step 1 — Obtain Your OAuth 2.0 Client Credentials
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showStep1 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showStep1}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>Mitratech issues you a <code>client_id</code>, a <code>client_secret</code>, and a platform <code>username</code> / <code>password</code>. You do not need to register an app yourself — request these from your Mitratech onboarding contact before starting.</p>
                <p>Keep all four values secret. The <code>client_id</code> / <code>client_secret</code> pair authenticates your application; the <code>username</code> / <code>password</code> authenticates the Partner Admin (API Admin) platform user on whose behalf you call the API.</p>
                <p>Mitratech will also issue you an <code>x-api-key</code> which is required as a parameter with every ECI library endpoint request (except <code>/v2/oauth/token</code>).</p>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Step 2 — Exchange Credentials for a Bearer Token ── */}
        <div className={this.state.showStep2 ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleStep2} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Step 2 — Exchange Your Credentials for a Bearer Token
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showStep2 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showStep2}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>The API uses OAuth 2.0. Authenticate with the <strong>password grant</strong>: your <code>client_id</code> / <code>client_secret</code> are sent as an HTTP Basic header, and the platform <code>username</code> / <code>password</code> are sent in a form-encoded body.</p>

                <div style={{ backgroundColor: '#fff3cd', borderLeft: '6px solid #ffeeba', padding: '12px', marginTop: '15px', borderRadius: '4px', color: '#856404', fontSize: '14px' }}>
                  <strong>Note:</strong> The password grant is a legacy OAuth 2.0 flow (deprecated in OAuth 2.1). It is supported here for backward compatibility with platform-level credentials.
                </div>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Request</h4>
                <pre style={preStyle}>{`POST /v2/oauth/token
Authorization: Basic <BASE64_CLIENT_CREDENTIALS>
Content-Type: application/x-www-form-urlencoded`}</pre>

                <p><code>&lt;BASE64_CLIENT_CREDENTIALS&gt;</code> is the Base64 encoding of <code>&lt;CLIENT_ID&gt;:&lt;CLIENT_SECRET&gt;</code>. Generate it like so:</p>
                <pre style={preStyle}>{`echo -n "<CLIENT_ID>:<CLIENT_SECRET>" | base64`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>curl</h4>
                <pre style={preStyle}>{`curl -X POST "https://restapis.alpha01.trustmineral-staging.com/v2/oauth/token" \\
  -H "Authorization: Basic <BASE64_CLIENT_CREDENTIALS>" \\
  -H "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "grant_type=password" \\
  --data-urlencode "username=<USERNAME>" \\
  --data-urlencode "password=<PASSWORD>"`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Expected Response</h4>
                <pre style={preStyle}>{sampleTokenResponse}</pre>

                <p>Copy the <code>access_token</code> value — you will send it as a <code>Bearer</code> token on every subsequent call. It expires in <code>expires_in</code> seconds (&asymp;1 hour). When it expires, either repeat this call or use the <code>refresh_token</code> (valid 30 days) with <code>grant_type=refresh_token</code>.</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Refreshing the Token</h4>
                <p>When the token expires, exchange the refresh token (valid 30 days) for a new one — no username/password required. This call hits the OAuth endpoint, so it does <strong>not</strong> take the <code>x-api-key</code> header:</p>
                <pre style={preStyle}>{`curl -X POST "https://restapis.alpha01.trustmineral-staging.com/v2/oauth/token" \\
  -H "Authorization: Basic <BASE64_CLIENT_CREDENTIALS>" \\
  -H "Content-Type: application/x-www-form-urlencoded" \\
  --data-urlencode "grant_type=refresh_token" \\
  --data-urlencode "refresh_token=<REFRESH_TOKEN>"`}</pre>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Step 3 — Make a Taxonomy Call ── */}
        <div className={this.state.showStep3 ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleStep3} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Step 3 — Make a Taxonomy Call (Do This First)
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showStep3 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showStep3}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>Taxonomy endpoints return the static lookup values — content types, jurisdictions, and categories — that the content endpoints expect. <strong>Call taxonomy before any content call</strong> so you use valid <code>contentType</code>, jurisdiction, and category values.</p>
                <p>Send the bearer token from Step 2 on every request:</p>
                <pre style={preStyle}>{`Authorization: Bearer <ACCESS_TOKEN>`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>curl — Content Types</h4>
                <pre style={preStyle}>{`curl "https://restapis.alpha01.trustmineral-staging.com/v1/content/taxonomy/content-types" \\
  -H "Authorization: Bearer <ACCESS_TOKEN>" \\
  -H "x-api-key: <X_API_KEY>" \\
  -H "Accept: application/json"`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Expected Response (abridged)</h4>
                <pre style={preStyle}>{sampleContentTypesResponse}</pre>
                <p>The <code>contentType</code> field (e.g. <code>toolkits</code>) is the value you pass to the content endpoints in the next step.</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>curl — Jurisdictions (states + Federal)</h4>
                <pre style={preStyle}>{`curl "https://restapis.alpha01.trustmineral-staging.com/v1/content/taxonomy/jurisdictions" \\
  -H "Authorization: Bearer <ACCESS_TOKEN>" \\
  -H "x-api-key: <X_API_KEY>" \\
  -H "Accept: application/json"`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Expected Response (abridged)</h4>
                <pre style={preStyle}>{sampleJurisdictionsResponse}</pre>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Step 4 — Retrieve a Content Item ── */}
        <div className={this.state.showStep4 ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleStep4} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Step 4 — Retrieve a Content Item
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showStep4 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showStep4}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>Now that you have a valid <code>contentType</code>, list content from the sandbox. Use <code>expandDetails=true</code> so the response includes the full content object (including the HTML body you&apos;ll render in Step 5).</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>curl</h4>
                <pre style={preStyle}>{`curl "https://restapis.alpha01.trustmineral-staging.com/v1/content?contentType=toolkits&limit=1&expandDetails=true" \\
  -H "Authorization: Bearer <ACCESS_TOKEN>" \\
  -H "x-api-key: <X_API_KEY>" \\
  -H "Accept: application/json"`}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Expected Response (full object)</h4>
                <pre style={preStyle}>{sampleContentResponse}</pre>

                <p>The <code>data</code> array holds the content items. Each item&apos;s <code>body1</code> (and, when present, <code>body2</code>–<code>body5</code>) contains ready-to-render HTML.</p>
                <p>Long content is split across <code>body1</code>–<code>body5</code> by size — concatenate them in order and skip nulls (as shown in Step 5).</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Slim vs. Full Objects</h4>
                <p>Set <code>expandDetails=false</code> (the default) for a slim projection — ideal for list/search views. It omits the HTML body and returns only summary fields.</p>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Pagination</h4>
                <p><code>limit</code> defaults to 20 (max 50); <code>offset</code> defaults to 0 and must be less than <code>totalRecords</code>. Page through results with <code>offset</code>:</p>
                <pre style={preStyle}>{`# Page 2 (items 21-30)
curl "https://restapis.alpha01.trustmineral-staging.com/v1/content?contentType=toolkits&limit=10&offset=20&expandDetails=true" \\
  -H "Authorization: Bearer <ACCESS_TOKEN>" \\
  -H "x-api-key: <X_API_KEY>" \\
  -H "Accept: application/json"`}</pre>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Step 5 — Render the HTML Content Field ── */}
        <div className={this.state.showStep5 ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleStep5} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Step 5 — Render the HTML Content Field
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showStep5 ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showStep5}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>The <code>body1</code> field is an HTML fragment. Drop it into any container element to display it. Minimal example:</p>
                <pre style={preStyle}>{renderExample}</pre>

                <div style={{ backgroundColor: '#fff3cd', borderLeft: '6px solid #ffeeba', padding: '12px', marginTop: '15px', borderRadius: '4px', color: '#856404', fontSize: '14px' }}>
                  <strong>Security:</strong> Only render HTML from the ECI API in a trusted, sandboxed context. Never mix user-supplied input into the rendered fragment, and sanitize the HTML before injecting it (e.g. with DOMPurify) to avoid XSS.
                </div>

                <p style={{ marginTop: '15px' }}>If you embed the content in an <code>iframe</code>, configure an appropriate <code>Content-Security-Policy</code> and the <code>sandbox</code> attribute.</p>
                <p>That&apos;s a complete round trip: <strong>authenticate → look up taxonomy → fetch content → render</strong>.</p>
              </div>
            </Collapse>
          )}
        </div>

        {/* ── Error Handling ── */}
        <div className={this.state.showErrorHandling ? "opblock-summary-description is-open" : "opblock-summary-description"} style={{ paddingTop: '10px', scrollMarginTop: '80px', marginTop: '35px' }}>
          <div onClick={this.toggleErrorHandling} className="opblock-summary-description">
            <div style={{ fontSize: '16px', fontWeight: 'bold' }}>
              Error Handling
              <i className="material-icons pull-right" style={{ fontSize: '16px', cursor: 'pointer' }}>
                {this.state.showErrorHandling ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}
              </i>
            </div>
          </div>
          {Collapse && (
            <Collapse isOpened={this.state.showErrorHandling}>
              <div className="opblock-body" style={{ paddingTop: '10px' }}>
                <p>Every error response has the same shape:</p>
                <pre style={preStyle}>{sampleErrorResponse}</pre>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>Errors You May Encounter</h4>
                <table style={{ width: '100%', borderCollapse: 'collapse', border: '1px solid #ddd', marginTop: '15px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#e0e0e0', fontWeight: 'bold', textAlign: 'left' }}>
                      <th style={errorThStyle}>HTTP</th>
                      <th style={errorThStyle}>errorCode</th>
                      <th style={errorThStyle}>message</th>
                      <th style={errorThStyle}>What It Means</th>
                      <th style={errorThStyle}>What to Do</th>
                    </tr>
                  </thead>
                  <tbody>
                    {errorTableData.map((row, i) => (
                      <tr key={i} style={i % 2 === 0 ? {} : { backgroundColor: '#f9f9f9' }}>
                        <td style={errorTdStyle}>{row.http}</td>
                        <td style={errorTdStyle}>{row.errorCode}</td>
                        <td style={errorTdStyle}>{row.message}</td>
                        <td style={errorTdStyle}>{row.meaning}</td>
                        <td style={errorTdStyle}>{row.action}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>

                <h4 style={{ fontSize: '16px', fontWeight: 'bold', marginTop: '25px' }}>What&apos;s Next</h4>
                <p>This guide intentionally covers only the shortest path to a working response. For the full endpoint catalog — filters, pagination, sort, the complete Unified Content Object schema, single-item lookup (<code>GET /v1/content/&#123;contentType&#125;/&#123;id&#125;</code>), and asset retrieval — refer to the <strong>Embedded Compliance Intelligence Library API</strong> endpoints above.</p>
              </div>
            </Collapse>
          )}
        </div>

        </div>
      </div>
    );
  }
}

const thStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  textAlign: 'left',
  fontWeight: 'bold'
};

const tdStyle = {
  padding: '10px',
  border: '1px solid #ccc',
  color: '#363636',
  fontSize: '14px',
  verticalAlign: 'top'
};

const preStyle = {
  backgroundColor: '#f8f8f8',
  color: '#000',
  padding: '16px',
  borderRadius: '6px',
  overflowX: 'auto',
  fontFamily: 'Consolas, monospace',
  fontSize: '13px',
  border: '1px solid #ccc',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word'
};

const errorThStyle = {
  padding: '10px',
  border: '1px solid #ddd',
  textAlign: 'left'
};

const errorTdStyle = {
  padding: '10px',
  border: '1px solid #ddd',
  color: '#363636',
  fontSize: '14px',
  verticalAlign: 'top'
};

const sampleTokenResponse = `{
  "access_token": ".ofbzIiBoirSPnOxoUC2uxOo44c5CMn5j-h_Lyi2fG4E",
  "token_type": "bearer",
  "refresh_token": "iC4_PQQeFuvxjz736DBR-1q0X4R3fiH-f-9Pzmy19e4",
  "expires_in": 3599,
  "scope": "all"
}`;

const sampleContentTypesResponse = `{
  "requestReferenceId": "15c40e11-9a1a-4136-a4a6-9b7221ce14c3",
  "status": "OK",
  "code": "200",
  "totalRecords": 9,
  "content-types": [
    { "id": "toolkit", "name": "Toolkit", "contentType": "toolkits", "documentTypes": null },
    { "id": "law", "name": "Law", "contentType": "laws", "documentTypes": null },
    {
      "id": "document",
      "name": "Document",
      "contentType": "documents",
      "documentTypes": [
        { "id": "guide", "name": "Guide", "documentType": "guides" },
        { "id": "chart", "name": "Chart", "documentType": "charts" },
        { "id": "checklist", "name": "Checklist", "documentType": "checklists" }
      ]
    }
  ]
}`;

const sampleJurisdictionsResponse = `{
  "requestReferenceId": "b932d78b-741c-4339-8426-d10ee964c723",
  "status": "OK",
  "code": "200",
  "totalRecords": 52,
  "jurisdictions": [
    { "id": "Federal", "name": "Federal", "jurisdiction": "Federal" },
    { "id": "AZ", "name": "Arizona", "jurisdiction": "State" },
    { "id": "CA", "name": "California", "jurisdiction": "State" }
  ]
}`;

const sampleContentResponse = `{
  "requestReferenceId": "b5067b66-6182-4fd0-aae5-4bb61bddb194",
  "status": "OK",
  "code": "200",
  "limit": "1",
  "offset": "0",
  "totalRecords": "91",
  "data": [
    {
      "id": "5mntQ9v4gouwLGV7SLFNFz",
      "contentType": "toolkits",
      "title": "Test Entry - Ashutosh 29.06",
      "summary": null,
      "jurisdictionType": "State",
      "categories": [
        { "id": "xOZwvvpDSu21TZg03GmVlk", "name": "Accommodations" },
        { "id": "O6MxmucbedK0uWorCTKYqA", "name": "Benefits" }
      ],
      "parentCategories": [
        { "id": "s28KFseZ20x8ujVMevDEpJ", "name": "Discrimination & Equal Employment" },
        { "id": "O6MxmucbedK0uWorCTKYqA", "name": "Benefits" }
      ],
      "totalEmployeeCount": [
        { "id": "NKAQqpRjAmiDR15C31Mpv", "name": "4 Or More Employees" }
      ],
      "jurisdictionEmployeeCount": [
        { "id": "NKAQqpRjAmiDR15C31Mpv", "name": "4 Or More Employees" }
      ],
      "updateDate": 1782715302830,
      "isLive": true,
      "body1": "<h1>Content HTML goes here...</h1>",
      "body2": null,
      "body3": null,
      "body4": null,
      "body5": null
    }
  ]
}`;

const renderExample = `<div id="compliance-content"></div>

<script>
  // body1 (and body2..body5, if present) from the Step 4 response
  const item = apiResponse.data[0];
  const html = [item.body1, item.body2, item.body3, item.body4, item.body5]
    .filter(Boolean)
    .join("");
  document.getElementById("compliance-content").innerHTML = html;
</script>`;

const sampleErrorResponse = `{
  "status": "UNAUTHORIZED",
  "code": 401,
  "errorCode": "1002",
  "message": "UNAUTHORIZED",
  "exceptionDetail": "Authentication failed for: /v1/content/...",
  "timestamp": "2026-05-05T23:34:01.907+0000"
}`;

const errorTableData = [
  {
    http: '400',
    errorCode: '4000',
    message: 'CONTENT_TYPE_REQUIRED',
    meaning: 'contentType query parameter is missing.',
    action: 'Always include contentType (from the Step 3 taxonomy call).'
  },
  {
    http: '400',
    errorCode: '4001',
    message: 'INVALID_CONTENT_TYPE',
    meaning: 'Not a supported value (e.g. toolkit instead of toolkits).',
    action: 'Use an exact value from the content-types taxonomy response.'
  },
  {
    http: '400',
    errorCode: '4003',
    message: 'INVALID_PAGINATION',
    meaning: 'limit or offset is out of range.',
    action: 'Keep limit in 1–50 and offset < totalRecords.'
  },
  {
    http: '401',
    errorCode: '1002 / 1003',
    message: 'UNAUTHORIZED / INVALID_TOKEN',
    meaning: 'The bearer token is missing, expired, malformed, or its signature/claims are invalid.',
    action: 'Repeat Step 2 to get a fresh access_token (or refresh it), then retry.'
  },
  {
    http: '403',
    errorCode: '1004',
    message: 'RESOURCE_ACCESS_DENIED',
    meaning: 'You authenticated successfully, but your account lacks the entitlement/SKU for this resource.',
    action: 'Contact your Mitratech onboarding representative to confirm your sandbox entitlements.'
  },
  {
    http: '404',
    errorCode: '2000',
    message: 'DATA_NOT_FOUND',
    meaning: 'No data matches the specified criteria.',
    action: 'Broaden your filters or verify your query parameters.'
  },
  {
    http: '404',
    errorCode: '3000',
    message: 'DOCUMENT_NOT_FOUND',
    meaning: 'Content item not found by id (single-item lookup).',
    action: 'Verify the content id.'
  },
  {
    http: '429',
    errorCode: '9000',
    message: 'TOO_MANY_REQUESTS',
    meaning: 'You have exceeded the rate limit for API calls.',
    action: 'Contact your Mitratech support representative to discuss usage plan.'
  },
  {
    http: '500',
    errorCode: '1011',
    message: 'INTERNAL_SERVER_ERROR',
    meaning: 'Unexpected server-side error.',
    action: 'Retry after a short delay; if it persists, contact Mitratech.'
  }
];

export default ECIQuickGuide;



// WEBPACK FOOTER //
// ./src/plugins/thinkhr/eci-quick-guide.jsx